import useVuelidate from '@vuelidate/core';
import { TypeCampaignEnum } from '@/types';
import { requiredWithMessage, includesValuesValidator } from '@/helpers/CustomValidator';
import type { FlowOperatorMetadata, ValidationResult } from '@/types/flow-types';
import { canDeleteTrigger } from '@/components/flows/operators/registry';
import Form from './Form.vue';

export interface SitePassTimeData {
  time_unit_select: {
    unit: string;
    value: number;
  };
  multiplebox_global_session: string;
}

export function createDefaultData(data: Partial<SitePassTimeData> = {}): SitePassTimeData {
  return {
    time_unit_select: data.time_unit_select ?? { unit: 'MINUTE', value: 10 },
    multiplebox_global_session: data.multiplebox_global_session ?? 'global',
  };
}

const SitePassTime: FlowOperatorMetadata<SitePassTimeData> = {
  id: 'boxsitepasstime',
  kind: 'trigger',
  label: 'flows.operators.sitePassTime.label',
  icon: 'fa-clock',
  hasConfiguration: true,
  availableIn: [],
  hidden: true,

  incompatibilities: {
    [TypeCampaignEnum.AUTOMATION]: {
      nextOperators: [
        'boxsitepasstime', 'boxperiodiclaunching', 'boxstatuscommand',
        'boxsendemail', 'boxsendsms', 'boxsendfbmessenger',
        'boxsendpushnotification', 'boxtriggerinternalevent', 'boxsendrcs', 'boxsendwhatsapp',
      ],
    },
  },

  Form,

  defaultData: createDefaultData,

  outputs: () => 1,

  async validate(data: SitePassTimeData): Promise<ValidationResult> {
    const rules = {
      time_unit_select: {
        requiredWithMessage: requiredWithMessage(),
      },
      multiplebox_global_session: {
        requiredWithMessage: requiredWithMessage(),
        includesValuesValidator: includesValuesValidator(['global', 'session']),
      },
    };

    const v$ = useVuelidate(rules, data);
    const success = await v$.value.$validate();
    return {
      success,
      validate: v$,
    };
  },

  canBeDeleted(operatorId: string, flow: any): Promise<boolean | string> {
    return canDeleteTrigger(flow, operatorId);
  },
};

export default SitePassTime;
